import { useBrainChat, useBrainChatStatus } from './BrainChatProvider';

/** The confirmed listing distinguishes an unsent draft from a bound conversation; a listed conversation
 * requires the projected rename capability, while read-only and delegated views never allow naming. */
export function useConversationNaming() {
  const { sessions, activeSessionId } = useBrainChat();
  const { readOnly, childFocus, membership } = useBrainChatStatus();
  const active = sessions.data?.find((session) => session.id === activeSessionId);
  const unsent = activeSessionId !== null && sessions.data !== undefined && active === undefined;
  return { active, unsent, editable: !readOnly && !childFocus && (membership?.capabilities.rename === true || unsent) };
}
